module.exports = __webpack_public_path__ + "img/survey-result-button.4d7bb857.png";